export default __webpack_public_path__ + "static/media/welcome3.4548ae2c.png";